import React, {createContext, useContext, useMemo, useState} from 'react'
import Loading from "../Loading/Loading";
import 'Assets/styles/default/components/PlaceholderLoading/index.less'

const Context = createContext({
    loading: false,
    setLoading: (status) => {},
})

export const usePlaceholderLoading = () => useContext(Context)
const PlaceholderLoading = ({ children }) => {
    const [ loading, setLoading ] = useState(false)

    const value = useMemo(() => ({
        loading, setLoading
    }), [ loading, setLoading ])

    return (
        <Context.Provider value={value}>
            {
                loading && (
                    <div className={'placeholder-loading'}>
                        <Loading/>
                    </div>
                )
            }
            {children}
        </Context.Provider>
    )
}

export default PlaceholderLoading
